import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { PageConfig } from '../../types';
import { useSchedulingLocationInfo } from '../use-scheduling-location-info';

type UseGetPractitionersV3DataParams = {
  selectedLocationId: string;
  selectedLocationIds?: string[];
  debouncedSearchValue?: string;
  pageConfig?: PageConfig;
  forCalendarView?: boolean;
  isEnabled?: boolean;
};

export const useGetPractitionersV3Data = ({
  selectedLocationId,
  selectedLocationIds,
  debouncedSearchValue = '',
  pageConfig,
  forCalendarView = false,
  isEnabled = true,
}: UseGetPractitionersV3DataParams) => {
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();
  const { isMultiLocation, parentLocationId } = useSchedulingLocationInfo();
  const isMultiLocationApiCall = !!parentLocationId && isMultiLocation;
  const request: SchedulerV3.Types.ListProvidersIO['input'] = {
    locationId: selectedLocationId,
    showHidden: !forCalendarView,
    ...(pageConfig?.limit && { limit: pageConfig?.limit }),
    ...(pageConfig?.page && { page: pageConfig?.page }),
    ...(debouncedSearchValue && { name: debouncedSearchValue }),
  };

  const singleLocationGetPractitionerQuery = SchedulerV3.Queries.useListProvidersQuery({
    request: request,
    options: {
      enabled: !isMultiLocationApiCall && isEnabled && isScheduleV3FlagEnabled && !!request.locationId,
    },
  });

  const requestForMulti: SchedulerV3.Types.ListProvidersMultiIO['input'] = {
    ...(pageConfig?.limit && { limit: pageConfig?.limit }),
    ...(pageConfig?.page && { page: pageConfig?.page }),
    ...(debouncedSearchValue && { name: debouncedSearchValue }),
    locationIds: (selectedLocationIds || (selectedLocationId ? [selectedLocationId] : [])).sort(),
    parentLocationId,
    forCalendarView,
  };

  const multiLocationGetPractitionerQuery = SchedulerV3.Queries.useListProvidersMultiQuery({
    request: requestForMulti,
    options: {
      enabled:
        isMultiLocationApiCall &&
        isEnabled &&
        isScheduleV3FlagEnabled &&
        !!requestForMulti.parentLocationId &&
        !!requestForMulti.locationIds.length,
    },
  });

  return isMultiLocationApiCall ? multiLocationGetPractitionerQuery : singleLocationGetPractitionerQuery;
};
